/**
 * Ruleta de descuentos — spin-wheel.js
 * Campañas desde metaobjetos Shopify (spin_wheel_campaign).
 */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'krono-spin-wheel-';

  function parseJson(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function getStorageKey(campaignId, suffix) {
    return STORAGE_PREFIX + campaignId + '-' + suffix;
  }

  function readStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      /* quota / private mode */
    }
  }

  function clearStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      /* quota / private mode */
    }
  }

  function matchesScope(root) {
    var mode = (root.dataset.scopeMode || 'all_store').toLowerCase();
    if (mode === 'all_store') return true;

    var template = (root.dataset.template || '').toLowerCase();
    var templates = parseJson(root.querySelector('[data-spin-wheel-target-templates]'), []);
    var urls = parseJson(root.querySelector('[data-spin-wheel-target-urls]'), []);
    var path = window.location.pathname.toLowerCase();

    for (var i = 0; i < templates.length; i++) {
      if (String(templates[i]).toLowerCase().trim() === template) return true;
    }

    for (var j = 0; j < urls.length; j++) {
      var target = String(urls[j]).trim().toLowerCase();
      if (!target) continue;
      if (target === path) return true;
      var normalized = target.replace(/\/$/, '');
      if (normalized && path.indexOf(normalized) === 0) return true;
    }

    return false;
  }

  function isDismissed(root) {
    var key = getStorageKey(root.dataset.campaignId, 'dismissed-at');
    var dismissedAt = readStorage(key);
    if (!dismissedAt) return false;

    var hours = parseInt(root.dataset.cooldownHours, 10) || 24;
    var elapsed = Date.now() - parseInt(dismissedAt, 10);
    return elapsed < hours * 3600000;
  }

  function getSpinCount(root) {
    var key = getStorageKey(root.dataset.campaignId, 'spin-count');
    return parseInt(readStorage(key) || '0', 10);
  }

  function incrementSpinCount(root) {
    var key = getStorageKey(root.dataset.campaignId, 'spin-count');
    var count = getSpinCount(root) + 1;
    writeStorage(key, String(count));
    return count;
  }

  function canSpinAgain(root) {
    var max = parseInt(root.dataset.maxSpins, 10);
    if (max === 0) return true;
    return getSpinCount(root) < max;
  }

  function setDismissed(root) {
    writeStorage(getStorageKey(root.dataset.campaignId, 'dismissed-at'), String(Date.now()));
  }

  function stripHtml(text) {
    return text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function parseKnownCustomerError(errorText) {
    var lowerError = (errorText || '').toLowerCase();

    var existingPatterns = [
      'already been taken',
      'already subscribed',
      'ya está suscrito',
      'ya esta suscrito',
      'has already been',
      'ya se ha suscrito'
    ];

    for (var i = 0; i < existingPatterns.length; i++) {
      if (lowerError.indexOf(existingPatterns[i]) !== -1) {
        return { ok: true, existing: true };
      }
    }

    return {
      ok: false,
      message: errorText || 'No se pudo registrar el email. Intenta de nuevo.'
    };
  }

  function inspectCustomerForm(doc, formId) {
    if (!doc) return null;

    function checkForm(formEl) {
      if (!formEl) return null;

      if (formEl.querySelector('[data-spin-wheel-subscribe-success]')) {
        return { ok: true };
      }

      var errorNode = formEl.querySelector('[data-spin-wheel-subscribe-error]');
      if (errorNode) {
        var errorResult = parseKnownCustomerError(stripHtml(errorNode.innerHTML));
        if (errorResult.ok) return errorResult;
        return { ok: false, definiteError: true, message: errorResult.message };
      }

      var visibleError = formEl.querySelector(
        '.site-footer__newsletter-error, .form-message--error, .input-error-message'
      );
      if (visibleError) {
        var visibleErrorText = stripHtml(visibleError.textContent || visibleError.innerHTML);
        if (visibleErrorText.length > 2) {
          var visibleResult = parseKnownCustomerError(visibleErrorText);
          if (visibleResult.ok) return visibleResult;
          return { ok: false, definiteError: true, message: visibleResult.message };
        }
      }

      var successEl = formEl.querySelector('.form-message--success, .note.form-success');
      if (successEl) {
        var successText = stripHtml(successEl.textContent || successEl.innerHTML);
        if (successText.length > 2) {
          return { ok: true };
        }
      }

      return null;
    }

    var spinForm = formId ? doc.getElementById(formId) : null;
    var spinResult = checkForm(spinForm);
    if (spinResult) return spinResult;

    return checkForm(doc.getElementById('ContactFooter'));
  }

  function isCloudflareChallenge(html) {
    return (
      html.indexOf('Verifying your connection') !== -1 ||
      html.indexOf('Verificando la conexión') !== -1 ||
      html.indexOf('challenge-error-text') !== -1
    );
  }

  function looksLikeSuccessfulStorefrontResponse(doc, formId, html) {
    if (!doc || !html || html.length < 1500) return false;
    if (isCloudflareChallenge(html)) return false;

    var spinForm = formId ? doc.getElementById(formId) : null;
    if (!spinForm && !doc.querySelector('[data-spin-wheel-root]')) return false;

    var parsed = inspectCustomerForm(doc, formId);
    if (parsed && parsed.definiteError) return false;
    if (parsed && parsed.ok) return true;

    return true;
  }

  function pickWeightedIndex(prizes) {
    var total = 0;
    for (var i = 0; i < prizes.length; i++) {
      total += Math.max(1, parseInt(prizes[i].weight, 10) || 1);
    }
    var rand = Math.random() * total;
    for (var j = 0; j < prizes.length; j++) {
      rand -= Math.max(1, parseInt(prizes[j].weight, 10) || 1);
      if (rand <= 0) return j;
    }
    return prizes.length - 1;
  }

  function buildConicGradient(prizes) {
    var n = prizes.length;
    var segment = 360 / n;
    var parts = [];
    for (var i = 0; i < n; i++) {
      var start = (i * segment).toFixed(2);
      var end = ((i + 1) * segment).toFixed(2);
      parts.push(prizes[i].color + ' ' + start + 'deg ' + end + 'deg');
    }
    return 'conic-gradient(from -90deg, ' + parts.join(', ') + ')';
  }

  function buildLabels(container, prizes) {
    container.innerHTML = '';
    var n = prizes.length;
    var segment = 360 / n;

    for (var i = 0; i < n; i++) {
      var li = document.createElement('li');
      li.className = 'spin-wheel-label';
      var angle = i * segment + segment / 2;
      li.style.transform = 'rotate(' + angle + 'deg)';

      var span = document.createElement('span');
      span.className = 'spin-wheel-label__text';
      span.textContent = prizes[i].label;
      span.style.transform = 'rotate(-' + angle + 'deg)';
      li.appendChild(span);

      container.appendChild(li);
    }
  }

  function calcSpinRotation(prizeIndex, total) {
    var segment = 360 / total;
    var segmentCenter = prizeIndex * segment + segment / 2;
    var fullTurns = 5 + Math.floor(Math.random() * 3);
    return fullTurns * 360 + (360 - segmentCenter);
  }

  function SpinWheel(root) {
    this.root = root;
    this.overlay = root.querySelector('[data-spin-wheel-overlay]');
    this.modal = root.querySelector('.spin-wheel-modal');
    this.disc = root.querySelector('[data-spin-wheel-disc]');
    this.labelsEl = root.querySelector('[data-spin-wheel-labels]');
    this.form = root.querySelector('.spin-wheel-form');
    this.spinBtn = root.querySelector('[data-spin-wheel-spin]');
    this.formError = root.querySelector('[data-spin-wheel-form-error]');
    this.resultEl = root.querySelector('[data-spin-wheel-result]');
    this.codeEl = root.querySelector('[data-spin-wheel-code]');
    this.prizeLabelEl = root.querySelector('[data-spin-wheel-prize-label]');
    this.copyBtn = root.querySelector('[data-spin-wheel-copy]');
    this.formWrap = root.querySelector('[data-spin-wheel-form-wrap]');
    this.floatingBtn = root.querySelector('[data-spin-wheel-open]');
    this.prizes = parseJson(root.querySelector('[data-spin-wheel-prizes]'), []);
    this.isOpen = false;
    this.hasSpunThisSession = false;
    this.autoTimer = null;
    this.submitIframe = null;
    this._scrollLocked = false;

    this.bindEvents();

    if (this.prizes.length < 2) {
      this.setFloatingVisible(false);
      return;
    }

    this.prepareForm();
    this.init();
    this.checkPostSubmitState();
  }

  SpinWheel.prototype.prepareForm = function () {
    if (!this.form) return;

    var action = this.form.getAttribute('action') || '/contact';
    if (action.indexOf('#') !== -1) {
      this.form.setAttribute('action', action.split('#')[0]);
    }
  };

  SpinWheel.prototype.lockPageScroll = function () {
    if (this._scrollLocked) return;

    this._savedScrollX = window.scrollX || window.pageXOffset || 0;
    this._savedScrollY = window.scrollY || window.pageYOffset || 0;
    this._scrollLocked = true;

    document.body.classList.add('spin-wheel-scroll-lock');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this._savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  SpinWheel.prototype.unlockPageScroll = function () {
    if (!this._scrollLocked) return;

    var x = this._savedScrollX || 0;
    var y = this._savedScrollY || 0;

    this._scrollLocked = false;
    document.body.classList.remove('spin-wheel-scroll-lock');
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(x, y);
  };

  SpinWheel.prototype.getSpinLabel = function () {
    return this.root.dataset.spinLabel || 'Girar la ruleta';
  };

  SpinWheel.prototype.getPendingSubmitKey = function () {
    return getStorageKey(this.root.dataset.campaignId, 'pending-submit');
  };

  SpinWheel.prototype.markPendingSubmit = function () {
    writeStorage(this.getPendingSubmitKey(), String(Date.now()));
  };

  SpinWheel.prototype.clearPendingSubmit = function () {
    clearStorage(this.getPendingSubmitKey());
  };

  SpinWheel.prototype.hasPendingSubmit = function () {
    var val = readStorage(this.getPendingSubmitKey());
    if (!val) return false;
    var ts = parseInt(val, 10);
    if (!ts || Date.now() - ts > 120000) {
      clearStorage(this.getPendingSubmitKey());
      return false;
    }
    return true;
  };

  SpinWheel.prototype.isFormReturnHash = function () {
    if (!this.form || !this.form.id) return false;
    var hash = (window.location.hash || '').replace(/^#/, '');
    return hash === this.form.id;
  };

  SpinWheel.prototype.cleanReturnHash = function () {
    if (!this.isFormReturnHash()) return;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  };

  SpinWheel.prototype.setFloatingVisible = function (visible) {
    if (!this.floatingBtn) return;
    this.floatingBtn.hidden = !visible;
    this.floatingBtn.style.display = visible ? '' : 'none';
  };

  SpinWheel.prototype.canShowPopup = function (manualOpen) {
    if (!matchesScope(this.root)) return false;
    if (!manualOpen && isDismissed(this.root)) return false;
    if (!canSpinAgain(this.root)) return false;
    return true;
  };

  SpinWheel.prototype.shouldShowFloatingButton = function () {
    if (!matchesScope(this.root)) return false;
    if (!canSpinAgain(this.root)) return false;
    return true;
  };

  SpinWheel.prototype.init = function () {
    if (!matchesScope(this.root)) {
      this.setFloatingVisible(false);
      return;
    }

    if (this.disc) {
      this.disc.style.background = buildConicGradient(this.prizes);
    }
    if (this.labelsEl) {
      buildLabels(this.labelsEl, this.prizes);
    }

    var triggerMode = (this.root.dataset.triggerMode || 'manual').toLowerCase();
    var showFloating = this.root.dataset.showFloating === 'true';

    if (showFloating && this.shouldShowFloatingButton()) {
      this.setFloatingVisible(true);
    } else {
      this.setFloatingVisible(false);
    }

    this.updateSpinButtonState();

    if (!isDismissed(this.root) && (triggerMode === 'auto' || triggerMode === 'both')) {
      this.setupAutoTrigger();
    }
  };

  SpinWheel.prototype.bindEvents = function () {
    var self = this;

    this.root.querySelectorAll('[data-spin-wheel-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.open(true);
      });
    });

    this.root.querySelectorAll('[data-spin-wheel-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.close(true);
      });
    });

    var dismissLink = this.root.querySelector('[data-spin-wheel-dismiss]');
    if (dismissLink) {
      dismissLink.addEventListener('click', function (e) {
        var href = (self.root.dataset.dismissUrl || '').trim();
        setDismissed(self.root);
        var isCloseOnly = !href || href === '#' || href === '#!';
        if (isCloseOnly) {
          e.preventDefault();
        }
        self.close(false);
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', function (e) {
        if (e.target === self.overlay) self.close(true);
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        self.handleFormSubmit(e);
      });

      this.form.querySelectorAll('[data-spin-wheel-field], [data-spin-wheel-privacy]').forEach(function (field) {
        field.addEventListener('input', function () {
          self.updateSpinButtonState();
        });
        field.addEventListener('change', function () {
          self.updateSpinButtonState();
        });
      });
    }

    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', function () {
        self.copyCode();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close(true);
    });
  };

  SpinWheel.prototype.setupAutoTrigger = function () {
    var mode = (this.root.dataset.triggerMode || 'manual').toLowerCase();
    if (mode !== 'auto' && mode !== 'both') return;
    if (!this.canShowPopup()) return;

    var delay = (parseInt(this.root.dataset.autoDelay, 10) || 5) * 1000;
    var self = this;
    this.autoTimer = setTimeout(function () {
      if (!self.isOpen) self.open();
    }, delay);
  };

  SpinWheel.prototype.updateSpinButtonState = function () {
    if (!this.spinBtn || !this.form) return;
    this.spinBtn.disabled = !this.isFormValid();
  };

  SpinWheel.prototype.isFormValid = function () {
    if (!this.form) return true;

    var requireEmail = this.root.dataset.requireEmail === 'true';
    if (requireEmail) {
      var emailInput = this.form.querySelector('[data-spin-wheel-email]') ||
        this.form.querySelector('input[type="email"][name="contact[email]"]');
      if (emailInput && !emailInput.value.trim()) return false;
      if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) return false;
    }

    var requiredFields = this.form.querySelectorAll('[data-spin-wheel-required]');
    for (var i = 0; i < requiredFields.length; i++) {
      var field = requiredFields[i];
      if (field.type === 'checkbox' && !field.checked) return false;
      if (field.type !== 'checkbox' && !field.value.trim()) return false;
    }

    var privacyRequired = this.root.dataset.privacyRequired === 'true';
    if (privacyRequired) {
      var privacy = this.form.querySelector('[data-spin-wheel-privacy]');
      if (privacy && !privacy.checked) return false;
    }

    return true;
  };

  SpinWheel.prototype.open = function (manualOpen) {
    if (this.isOpen) return;
    if (!this.overlay) return;
    if (!this.canShowPopup(manualOpen)) return;
    this.openAfterSubmit();
  };

  SpinWheel.prototype.openAfterSubmit = function () {
    if (this.isOpen || !this.overlay) return;

    if (this.autoTimer) {
      clearTimeout(this.autoTimer);
      this.autoTimer = null;
    }

    this.isOpen = true;
    this.overlay.removeAttribute('hidden');
    this.overlay.setAttribute('aria-hidden', 'false');

    var overlay = this.overlay;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
    });

    this.lockPageScroll();
  };

  SpinWheel.prototype.close = function (applyDismiss) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.unlockPageScroll();

    var self = this;
    setTimeout(function () {
      self.overlay.setAttribute('hidden', '');
    }, 350);

    if (applyDismiss && !this.hasSpunThisSession) {
      setDismissed(this.root);
    }
  };

  SpinWheel.prototype.showFormError = function (msg) {
    if (!this.formError) return;
    this.formError.textContent = msg;
    this.formError.hidden = false;
  };

  SpinWheel.prototype.hideFormError = function () {
    if (this.formError) this.formError.hidden = true;
  };

  SpinWheel.prototype.submitCustomerForm = function () {
    var formData = new FormData(this.form);

    if (!formData.has('form_type')) {
      formData.append('form_type', 'customer');
    }
    if (!formData.has('utf8')) {
      formData.append('utf8', '\u2713');
    }

    return fetch(this.form.action || '/contact', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    }).then(function (response) {
      return response.text();
    }).then(function (html) {
      var isSuccess =
        html.indexOf('form-message--success') !== -1 ||
        html.indexOf('newsletter_confirmation') !== -1 ||
        html.indexOf('posted_successfully') !== -1 ||
        html.indexOf('form-success') !== -1;

      if (isSuccess) return true;

      var isAlreadySubscribed =
        html.indexOf('already') !== -1 ||
        html.indexOf('ya está') !== -1 ||
        html.indexOf('ya esta') !== -1 ||
        html.indexOf('already subscribed') !== -1;

      if (isAlreadySubscribed) return true;

      var errorMatch = html.match(/form-message[^>]*>([^<]+)/i);
      throw new Error(errorMatch ? errorMatch[1].trim() : 'No se pudo registrar el email. Intenta de nuevo.');
    });
  };

  SpinWheel.prototype.ensureSubmitIframe = function () {
    if (this.submitIframe && this.submitIframe.parentNode) {
      return this.submitIframe;
    }

    var iframe = document.createElement('iframe');
    iframe.name = 'spin-wheel-submit-frame';
    iframe.title = 'Spin wheel submit';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.tabIndex = -1;
    iframe.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;border:0;';
    document.body.appendChild(iframe);
    this.submitIframe = iframe;
    return iframe;
  };

  SpinWheel.prototype.submitViaIframe = function () {
    var form = this.form;
    var formId = form.id;
    var iframe = this.ensureSubmitIframe();
    var wheel = this;

    return new Promise(function (resolve, reject) {
      var settled = false;
      var pollCount = 0;
      var maxPolls = 50;
      var pollTimer = null;
      var lastDoc = null;
      var lastHtml = '';
      var sawCloudflare = false;

      function cleanup() {
        if (pollTimer) clearInterval(pollTimer);
        form.removeAttribute('target');
      }

      function finish(success, message) {
        if (settled) return;
        settled = true;
        cleanup();
        if (success) resolve(true);
        else reject(new Error(message || 'No se pudo registrar el email. Intenta de nuevo.'));
      }

      function tryParse() {
        pollCount++;

        var doc = null;
        try {
          doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        } catch (err) {
          if (pollCount > maxPolls) {
            finish(sawCloudflare ? false : true, sawCloudflare ? 'No se pudo validar el registro. Recarga e intenta de nuevo.' : undefined);
          }
          return;
        }

        if (!doc || !doc.body) {
          if (pollCount > maxPolls) {
            finish(sawCloudflare ? false : true);
          }
          return;
        }

        var html = doc.documentElement ? doc.documentElement.innerHTML : '';
        if (!html || html.length < 200) {
          if (pollCount > maxPolls) {
            finish(sawCloudflare ? false : true);
          }
          return;
        }

        lastDoc = doc;
        lastHtml = html;

        if (isCloudflareChallenge(html)) {
          sawCloudflare = true;
          if (pollCount > maxPolls) {
            finish(false, 'No se pudo validar el registro. Recarga e intenta de nuevo.');
          }
          return;
        }

        var parsed = inspectCustomerForm(doc, formId);
        if (parsed && parsed.ok) {
          finish(true);
          return;
        }

        if (parsed && parsed.definiteError) {
          finish(false, parsed.message);
          return;
        }

        if (looksLikeSuccessfulStorefrontResponse(doc, formId, html)) {
          finish(true);
          return;
        }

        if (pollCount > maxPolls) {
          if (lastDoc && looksLikeSuccessfulStorefrontResponse(lastDoc, formId, lastHtml)) {
            finish(true);
          } else {
            finish(!sawCloudflare);
          }
        }
      }

      pollTimer = setInterval(tryParse, 200);
      iframe.addEventListener('load', tryParse);

      form.setAttribute('target', iframe.name);
      form.submit();
    });
  };

  SpinWheel.prototype.checkPostSubmitState = function () {
    if (!this.form) return;

    var successMarker = this.form.querySelector('[data-spin-wheel-subscribe-success]');
    var errorMarker = this.form.querySelector('[data-spin-wheel-subscribe-error]');
    var isReturn = this.isFormReturnHash() || this.hasPendingSubmit();

    if (successMarker) {
      this.clearPendingSubmit();
      this.cleanReturnHash();
      this.openAfterSubmit();
      this.runPostSubmitSuccess();
      return;
    }

    if (errorMarker) {
      var errorResult = parseKnownCustomerError(stripHtml(errorMarker.innerHTML));
      this.clearPendingSubmit();
      this.cleanReturnHash();

      if (errorResult.ok) {
        this.openAfterSubmit();
        this.runPostSubmitSuccess();
        return;
      }

      this.openAfterSubmit();
      this.showFormError(errorResult.message);
      return;
    }

    if (this.hasPendingSubmit()) {
      this.clearPendingSubmit();
      this.cleanReturnHash();
      this.openAfterSubmit();
      this.runPostSubmitSuccess();
      return;
    }

    if (this.isFormReturnHash()) {
      this.cleanReturnHash();
    }
  };

  SpinWheel.prototype.runPostSubmitSuccess = function () {
    var self = this;

    if (!canSpinAgain(this.root)) {
      this.showFormError('Ya alcanzaste el máximo de participaciones.');
      return;
    }

    this.hideFormError();
    this.hasSpunThisSession = true;

    if (this.formWrap) this.formWrap.hidden = false;
    if (this.resultEl) this.resultEl.hidden = true;
    if (this.spinBtn) {
      this.spinBtn.disabled = true;
      this.spinBtn.textContent = 'Girando…';
    }
    this.modal.classList.add('is-spinning');

    this.animateSpin()
      .then(function (prize) {
        incrementSpinCount(self.root);
        self.showResult(prize);
      })
      .catch(function () {
        if (self.spinBtn) {
          self.spinBtn.disabled = !self.isFormValid();
          self.spinBtn.textContent = self.getSpinLabel();
        }
        self.modal.classList.remove('is-spinning');
      });
  };

  SpinWheel.prototype.handleFormSubmit = function (event) {
    event.preventDefault();

    if (!this.isFormValid()) {
      this.showFormError('Completa todos los campos obligatorios.');
      return;
    }

    if (!canSpinAgain(this.root)) {
      this.showFormError('Ya alcanzaste el máximo de participaciones.');
      return;
    }

    this.hideFormError();
    this.markPendingSubmit();

    if (this.spinBtn) {
      this.spinBtn.textContent = 'Registrando…';
    }

    var self = this;

    this.submitViaIframe()
      .catch(function () {
        return self.submitCustomerForm();
      })
      .then(function () {
        self.clearPendingSubmit();
        self.runPostSubmitSuccess();
      })
      .catch(function (err) {
        self.clearPendingSubmit();
        self.showFormError(err.message || 'No se pudo registrar el email. Intenta de nuevo.');
        if (self.spinBtn) {
          self.spinBtn.disabled = !self.isFormValid();
          self.spinBtn.textContent = self.getSpinLabel();
        }
      });
  };

  SpinWheel.prototype.animateSpin = function () {
    var self = this;
    var prizeIndex = pickWeightedIndex(this.prizes);
    var prize = this.prizes[prizeIndex];
    var rotation = calcSpinRotation(prizeIndex, this.prizes.length);

    this.disc.classList.add('is-spinning');
    this.disc.style.transform = 'rotate(' + rotation + 'deg)';

    return new Promise(function (resolve) {
      setTimeout(function () {
        self.disc.classList.remove('is-spinning');
        resolve(prize);
      }, 4600);
    });
  };

  SpinWheel.prototype.showResult = function (prize) {
    this.modal.classList.remove('is-spinning');
    this.modal.classList.add('is-result');

    if (this.formWrap) this.formWrap.hidden = true;
    if (this.resultEl) this.resultEl.hidden = false;
    if (this.codeEl) this.codeEl.textContent = prize.discount_code || '—';
    if (this.prizeLabelEl) this.prizeLabelEl.textContent = prize.label || '';

    if (!canSpinAgain(this.root)) {
      this.setFloatingVisible(false);
    }
  };

  SpinWheel.prototype.copyCode = function () {
    var code = this.codeEl ? this.codeEl.textContent : '';
    if (!code) return;

    var self = this;
    var onCopied = function () {
      self.copyBtn.classList.add('is-copied');
      var original = self.copyBtn.textContent;
      self.copyBtn.textContent = '¡Copiado!';
      setTimeout(function () {
        self.copyBtn.classList.remove('is-copied');
        self.copyBtn.textContent = original;
      }, 2000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(onCopied);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      onCopied();
    }
  };

  function init() {
    document.querySelectorAll('[data-spin-wheel-root]').forEach(function (root) {
      new SpinWheel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
